export default "__VITE_ASSET__DOeQNsXS__"